module.exports = __webpack_public_path__ + "img/ic_arrow_forward.c93c807d.svg";